import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { selectGitRepo, setDefaultGitBranch } from '@/services/git/api';
import { useAuthStoreV1 } from '@/stores/authStore_v1';

export function useSelectGitRepo(): UseMutationResult<void, Error, string> {
  const queryClient = useQueryClient();
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id);

  return useMutation({
    mutationFn: (repoId: string) => selectGitRepo(orgId!, repoId),
    onSuccess: () => {
      // Clear the working branch in DB — fire and forget, best effort.
      setDefaultGitBranch(orgId!, null).catch(() => {});
      // Synchronously zero the cache. Do NOT invalidate — a background GET would
      // race the PUT above and return the stale branch before it commits.
      // The cache stays null until the user explicitly sets a new branch.
      queryClient.setQueryData(['defaultGitBranch', orgId], null);
      queryClient.invalidateQueries({ queryKey: ['gitSelectedRepo', orgId] });
      queryClient.invalidateQueries({ queryKey: ['gitRepos', orgId] });
    },
  });
}
